__turbopack_context__.v({
  "container": "TextBlock-module__bgzcGW__container",
});
